import {h, Fragment} from "preact";

import * as I from "../utils/icons.jsx";

export function HeaderContainer({children}) {
	return <div class="relative flex h-11 w-full items-stretch border-t border-b border-t-harifzinc-900 border-b-harifzinc-900 bg-harif-800 text-white">
		{children}
	</div>
}
export function TimeFilterHolder({children, ...props}) {
	return <div class="fn-timefilter flex h-full shrink grow justify-stretch text-xs" {...props}>
		{children}
	</div>
}
export function TimeFilterBtn({children, active, ...props}) {
	if (!active) {
		return <div class="flex h-full w-8 shrink grow items-center justify-center border-b-2 border-r border-harifzinc-900 border-b-transparent" {...props}>
			{children}
		</div>
	}
	return <div class="flex h-full w-8 shrink grow items-center justify-center border-b-2 border-r border-harifzinc-900 border-b-amber-500" {...props}>
		{children}
	</div>
}
export function SearchBar({onClick, onInput, open, children, value, ref}) {
	return <div class="w-11" onClick={onClick} ref={ref}>
		<div 
			tabIndex={0}
			class={
				"absolute right-0 top-0 flex h-full bg-harif-900 text-white transition-all focus-within:w-full hover:w-full "
				+(open ? 'w-full' : 'w-11')
			}
		>
			<input type="text" class="mr-11 w-full min-w-0 bg-transparent px-2 text-white" placeholder="Search" onInput={onInput} value={value} />
			<div class="absolute bottom-0 right-0 top-0 flex w-11 items-center justify-center">
				<div class="h-4 w-4">
					<I.SearchIcon class="fill-current h-full" />
				</div>
			</div>
			{open && children}
		</div>
	</div>
}

export function SearchContentWrapper({children, ref}) {
	return <div class="absolute h-30 left-0 right-0 top-full overflow-hidden z-50" ref={ref}>
		{children}
	</div>
}

export function SearchPopupContainer({children}) {
	return <div class="bg-harifzinc-700 border border-amber-600 w-full text-white">{children}</div>
}
export function SearchPopupHeader({children}) {
	return <div class="h-8 bg-harifzinc-800 border-b border-harifzinc-800 flex justify-between items-center text-sm">{children}</div>
}
export function SearchPopupLabel({children}) {
	return <div class="px-2">{children}</div>
}
export function SearchPopupClose({children, onClick}) {
	return <div class="px-2" onClick={onClick}>{children}</div>
}
export function SearchPopupEventsHolder({children}) {
	return <div class="h-52 overflow-y-auto">{children}</div>
}
export function SearchEventRow({children, onClick}) {
	return <div class="h-14 bg-harifzinc-700 border-b border-harifzinc-800 text-white py-2 flex justify-between flex-col" onClick={onClick}>{children}</div>
}
export function SearchEventName({children}) {
	return <div class="search-event-name px-2 text-sm pb-1 truncate">{children}</div>
}
export function SearchEventInfoRow({children}) {
	return <div class="flex items-center px-2 text-xs gap-1">{children}</div>
}
export function SearchEventFlag({children}) {
	return <div class="w-4 flex relative top-px">{children}</div>
}
export function SearchEventTournamentName({children}) {
	return <div class="tournament truncate">{children}</div>
}
export function SearchEventSeparator({children}) {
	return <div class="grow">{children}</div>
}
export function SearchEventSportFlag({children}) {
	return <div>{children}</div>
}

function SearchPopupExample() {
	return <SearchContentWrapper>
		<SearchPopupContainer>
			<SearchPopupHeader>
				<SearchPopupLabel>Search Results</SearchPopupLabel>
				<SearchPopupClose>Search Results</SearchPopupClose>
			</SearchPopupHeader>
			<SearchPopupEventsHolder>
				<SearchEventRow>
					<SearchEventName>HOME - AWAY</SearchEventName>
					<SearchEventInfoRow>
						<SearchEventFlag />
						<SearchEventTournamentName>Sport / Category / Tournament</SearchEventTournamentName>
						<SearchEventSeparator />
						<SearchEventSportFlag />
					</SearchEventInfoRow>
				</SearchEventRow>
			</SearchPopupEventsHolder>
		</SearchPopupContainer>
	</SearchContentWrapper>
}

export function SportsHolder({children, ...props}) {
	return <div class="scrollbar-hide h-16 w-full items-stretch overflow-x-auto overflow-y-hidden border-t border-b border-harif-800 bg-harif-800 text-white">
		<div class="flex h-full min-w-full">
			{children}
		</div>
	</div>
}
export function SportButton({sport, active, ...props}) {
	return <SportLikeButton active={active} {...props}>
		<SportIconBox>
			<SportIcon sport={sport} />
			<span class="block absolute -top-1.5 -right-2 text-xs">{sport.count}</span>
		</SportIconBox>
		<SportName>{sport.name}</SportName>
    </SportLikeButton>
}
export function SportLikeButton({sport, active, children, ...props}) {
	return <div class={"flex h-full w-16 shrink-0 grow-0 flex-col items-center justify-start pt-1.5 border-b-2 "+(active ? 'border-b-amber-500' : 'border-b-transparent')} {...props}>
		{children}
    </div>
}
export function SportIconBox({children}) {
	return <div class="relative flex justify-center items-center h-8 w-8">
		{children}
    </div>
}
export function SportIcon({sport}) {
	return <span class={"text-2xl sporticon sp_"+(sport.id && sport.id.split('/')[2])}></span>
}
export function SportIconSmall({sport}) {
	return <span class={"text-sm sporticon sp_"+(sport.id && sport.id.split('/')[2])}></span>
}
export function SportName({children}) {
	return <span class="text-xs truncate max-w-full">{children}</span>
}

export function SportStrip({sport}) {
	return <div class="flex h-9 w-full items-center justify-between bg-dark-teal px-2 text-sm text-white">
		<div class="px-2">{sport.name}</div>
		<div class="flex w-28 justify-between">
			<div></div>
			<div class="">{sport.count} Matches</div>
		</div>
	</div>
}

export function PageContainer({children}) {
	return <div class="w-full border-b-harifzinc-900 bg-harifzinc-800 text-white">
		{children}
	</div>
}
export function CategorySelectionHolder({children}) {
	return <div class="fn-category">
		{children}
	</div>
}
export function CategorySelectionButton({category, checked, onChecked, open, ...props}) {
	return <CategorySelectionButtonRow {...props}>
		<CategoryIcon>icon</CategoryIcon>
		<CategoryName>{category.name}</CategoryName>
		<FlexSeparator />
		<CategoryChecbox checked={checked} onChecked={onChecked} />
		<CategoryChevron open={open} />
	</CategorySelectionButtonRow>
}
export function CategorySelectionButtonRow({children, ...props}) {
	return <div class="flex h-10 w-full items-center border-b border-b-harifzinc-900 bg-harif-900 text-sm text-white" {...props}>
		{children}
	</div>
}
export function CategoryIcon({children}) {
	return <div class="flex w-10 items-center justify-center">
		{children}
	</div>
}
export function CategoryName({children}) {
	return <div class="px-2">{children}</div>
}
export function FlexSeparator({children}) {
	return <div class="grow"></div>
}
export function CategoryChecbox({children, checked, onChecked}) {
	return <div class="flex w-10 items-center justify-center">
		<input type="checkbox" class="relative top-px" checked={checked} onClick={e => e.stopPropagation()} onInput={onChecked} />
	</div>
}
export function CategoryChevron({children, open}) {
	return <div class="flex w-10 items-center justify-center"><I.UpArrowIcon class={"h-4 transition-transform "+(open ? '' : 'rotate-180')} /></div>
}
export function TournamentSelectionHolder({children, open = true}) {
	return <div class={"overflow-y-hidden transition-all duration-300 "+(open ? 'max-h-[1999px]' : 'max-h-0')}>
			<div class="bg-harif-800">
			{children}
		</div>
	</div>	
}
export function TournamentSelectionButton({tournament, checked, onChecked, ...props}) {
	return <TournamentSelectionButtonRow {...props}>
		<CategoryIcon>icon</CategoryIcon>
		<TournamentName>{tournament.name}</TournamentName>
		<FlexSeparator />
		<CategoryChecbox checked={checked} onInput={onChecked} />
	</TournamentSelectionButtonRow>
}
export function TournamentSelectionButtonRow({children, ...props}) {
	return <div class="flex h-9 w-full items-center border-t border-t-harif-900 border-b border-b-harif-950 text-sm text-white" {...props}>
		{children}
	</div>
}
export function TournamentName({children}) {
	return <div class="px-2 truncate">{children}</div>;
}

function TemplateTournamentsMenuExample() {
	return <Fragment>
		<HeaderContainer>
			<TimeFilterHolder>
				<TimeFilterBtn>All</TimeFilterBtn>
				<TimeFilterBtn>3 hrs</TimeFilterBtn>
				<TimeFilterBtn>6 hrs</TimeFilterBtn>
				<TimeFilterBtn>8 hrs</TimeFilterBtn>
				<TimeFilterBtn>123 hrs</TimeFilterBtn>
			</TimeFilterHolder>
			<SearchBar />
		</HeaderContainer>
		<SportsHolder>
			<SportButton sport={{name: "Favorites"}} />
			<SportButton sport={{name: "Soccer"}} />
			<SportButton sport={{name: "Tennis"}} />
			<SportButton sport={{name: "Basketball"}} />
		</SportsHolder>
		<SportStrip sport={{name: "Soccer", count: 822}} />
		<PageContainer>
			<CategorySelectionHolder>
				<CategorySelectionButton category={{name: "Italy"}} />
				<TournamentSelectionHolder>
					<TournamentSelectionButton tournament={{name: "World"}} />
					<TournamentSelectionButton tournament={{name: "World"}} />
				</TournamentSelectionHolder>
			</CategorySelectionHolder>
		</PageContainer>
	</Fragment>
}

export function TournamentIcon({tournament, ...props}) {
	const [_s, _c, tournamentId] = tournament.code.split('/');
	return <span class={"h-4 w-4 inline-block bg-no-repeat bg-center bg-contain "+(props['class']||'')}></span>
}

